<template>
  <!--
    Jeśli loading = true (np. trwa pobieranie danych),
    pokaż spinner Bootstrapowy + komunikat "Ładowanie"
  -->
  <div v-if="loading" class="loading d-flex justify-content-center m-3">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    {{ t('loading') }}
  </div>

  <!--
    Jeśli loading = true oraz loadingToLong = true (np. przekroczono czas oczekiwania),
    pokaż komunikat o braku danych z lokalizacji
  -->
  <div v-if="loading && loadingToLong" class="loading d-flex justify-content-center m-3">
     {{ t('no-data-from-location') }}
  </div>
</template>

<script>
export default {
  name: "SpinnerElement",
  props: {
    // Czy trwa ładowanie? (triggeruje widoczność spinnnera)
    loading: { type: Boolean, default: false },
    // Czy ładowanie trwa zbyt długo? (pokaż specjalny komunikat)
    loadingToLong: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
/* Styl linii spinnera i tekstu */
.loading {
  line-height: 30px;
}
/* Dodatkowy margines dla spinnera względem tekstu */
.loading span {
  margin-right: 7px;
}
</style>
